// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610260735/js/" + chunkId + "." + {"44":"912c7276","225":"ec31e1ca","481":"6f02e59e","486":"234b46c2","770":"d4c65dda"}[chunkId] + ".0.10204493375568646.chunk.js";
};